import { ReactComponent as CloudSavingSpinnerImg } from "@/data-preparation-tool/icons/cloud-saving-spinner.svg";
import { selectIsSavingDialogOpen } from "@/data-preparation-tool/store/data-preparation-ui/draft-saving-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { WorkflowDialog } from "@faro-lotv/data-management";
import { JSX } from "react/jsx-runtime";

/**
 * @returns A dialog blocking the UI while pending draft changes are being saved,
 *  its visibility is controlled by `useSaveDraftChangesWithDialog`.
 */
export function SavingUserEditsDialog(): JSX.Element {
  const open = useAppSelector(selectIsSavingDialogOpen);
  return (
    <WorkflowDialog
      open={open}
      variant="notice"
      image={CloudSavingSpinnerImg}
      title="Saving your changes..."
      description="Please don't close the browser while we save."
    />
  );
}
